<template>
    <div class="flex">
        <div class="document-category-menu">
            <div class="text-white mt-4 mx-4 pb-2 mb-6 border-b border-dashed border-gray-400 uppercase">Categories</div>
            <ul class="categories">
                <li class="w-full px-4 py-2 mb-2 all-documents" :class="[selectedCategory == '' ? 'active' : '']" @click="selectCategory('')">
                    <div class="flex justify-between items-center">
                        <div class="text-base font-bold uppercase">All Reports</div>
                        <div class="document-count">{{ reports.all.length }}</div>
                    </div>
                </li>
                <li v-for="category in availableCategories" :key="category.id" :class="[selectedCategory == category.id ? 'active' : '']" @click="selectCategory(category.id)">                       
                    <div class="category" v-if="category.report_count > 0"  @click="toggleCategory(category.id)">
                        <div class="flex justify-between items-center">
                            <div class="text-base font-bold uppercase">{{ category.name }}</div>
                            <div class="document-count">{{ category.report_count }}</div>
                        </div>
                    </div>
                    <transition name="fade">
                        <ul v-if="categoryVisible(category.id)" class="subcategories">
                            <li class="subcategory"
                                v-for="(report, reportIndex) in reportsFor(category.id)" :key="reportIndex">
                                <div class="flex justify-between items-center">
                                    <div class="mr-4">
                                        <a :href="report.prep_url" class="text-lg">{{ report.name }}</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </transition>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    
    export default {
        props: {
            reportData: {
                type: [Array, Object],
                required: false
            },

            showCategory: {
                type: Number,
                required: false
            },

            showReport: {
                type: Number,
                required: false
            }
        },

        data() {
            return {
                selectedCategory: this.showCategory || '',
                selectedReport: this.showReport || '',
            }
        },

        created() {
            this.$store.dispatch('loadReports');
        },

        mounted() {
            this.reports.all = this.reportData;
            this.reports.filtered = this.reportData;            
        },

        watch: {
            filtered() {
                this.calculateReportCounts();
            },

            all() {
                this.calculateReportCounts();
            },

            availableCategories() {
                this.calculateReportCounts();
            },

            selectedCategory(categoryID) {
                if (categoryID == '') {
                    window.location = '/reports';
                }

                this.selectCategory(categoryID);
                this.availableCategories[categoryID].visible = true;

                this.$emit('filterRequest');
            },
        },

        computed: {
            ...mapState(['reports']),

            all() {
                return this.reports.all;
            },

            filtered() {
                return this.reports.filtered;
            },

            filters() {
                return {
                    category_id: this.selectedCategory,
                    report_id: this.selectedReport,
                }
            },

            availableCategories() {
                return _.each(_.keyBy(this.reports.categories, 'id'), (category) => {
                    category.visible = category.id == this.selectedCategory;
                });
            },

            availableReports() {
                if (this.selectedCategory == '') {
                    return '';
                }

                return _.filter(this.reports, (report) => {
                    return report.category_id == this.selectedCategory
                })
            }
        },

        methods: {
            reportsFor(categoryId) {
                return (this.reports.all || []).filter(report => report.category_id == categoryId);
            },

            toggleCategory(categoryID) {
                this.availableCategories[categoryID].visible = ! this.availableCategories[categoryID].visible;
            },

            categoryVisible(categoryID) {
                return this.availableCategories[categoryID].visible;
            },

            selectCategory(categoryID) {
                if (this.selectedCategory != categoryID) {
                    this.selectedSubCategory = '';                    
                }

                this.selectedCategory = categoryID;
            },

            calculateReportCounts() {
                // categories
                _.each(this.availableCategories, (category) => {
                    category.report_count = _.filter(this.reports.all, (report) => {
                        return report.category_id == category.id
                    }).length
                });
            },
        }
    }
</script>